/**
 * Created by IvanCai on 2017/4/19.
 */
import axios from 'axios'
import { domain } from '@/jslib/env'
import utils from './utils'
const dkAxios = axios.create({
  baseURL: domain,
  timeout: 20000
})

let timer = null

let keepHeader = (head) => {
  let head_obj = {}
  if('client-type' in head) Object.assign(head_obj, {'client-type': head["client-type"]})  // api => index/login_code

  return head_obj
}

dkAxios.interceptors.request.use(
  (config) => {

    let head = keepHeader(config.headers)

    config.headers = { 'token': utils.getCookie('user_token') }

    if(location.origin.includes('//localhost:')) {
      // config.headers = { 'token': '425c97a31ed190dc4acda74291a3976f' };
      // config.headers = {'token': '0c4b0b136aa21b211852df8d783352fd'}; // ylm token test 7926
      // config.headers = { 'token': '8c62c01408dd7e0e965a71c3ff80e0ae' }; // ylm token release 7926
      // config.headers = { 'token': '4a71e53003266d1a238c26f6f9053045' }; // ylm token release 3404
      // config.headers = { 'token': '83f561a4e61d6575947105f762474a2f' }; // ivy token test
    }

    Object.assign(config.headers, head)

    if (!timer) timer = setTimeout(() => { window.showLoading() }, 1000)

    return config
  },
  error => Promise.reject(error),
);

dkAxios.interceptors.response.use(
  (response) => {
    if (timer) {
      clearTimeout(timer)
      timer = null
      window.hideLoading()
    }

    const { data } = response

    if (Object.keys(data).length === 1 && data.error) {
      window.showTips(data.error.message, 'error')
      return Promise.reject(data.error)
    }

    if (data.code == 401 || data.code == 412) {
      // 非App内
      if(!utils.getPlatform().mfhApp){
        console.log('跳登录')
        location.href = 'signup?next_url=' + encodeURIComponent(location.pathname.slice(1)+location.search)
      }
      // app内
      if(utils.getEnv()==='android') window.android.jumpLogin()
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpLogin.postMessage({ })

      return Promise.reject()
    }

    return response
  },
  (error) => {
    if (timer) {
      clearTimeout(timer)
      timer = null
      try{
        window.hideLoading()
      }catch (e){
        console.log('request error', e)
      }
    }

    console.log('请求出错', error)

    const { status, data } = error.response;
    switch (status) {
      case 401:
      case 412:
        // 401或412说明token未传或失效，一般做重新登录操作
        break;
      case 500:
        // 后台服务器内部错误，一般向用户展示服务器错误信息
        window.showTips(data.error.message, 'error')
        break
      default:
        window.showTips(data.error.message, 'error')
        return Promise.reject(error);
    }
  },
);
export default dkAxios;
